import {token} from "@atlaskit/tokens";
import {GenericModal} from "~/components/genericModal";
import {AnankeButton} from "@vesta/ananke/components/anankeButton";

export function TableDeleteConfirmationModal({
    opened,
    onClose,
    onConfirm,
    title = "Are you sure you want to delete ?",
    description = "Once deleted, the information cannot be recovered. Click Confirm to permanently delete or Cancel to go back.",
    confirmLabel = "Delete",
    cancelLabel = "Cancel",
}: {
    opened: boolean
    onClose: () => void
    onConfirm: () => void
    title?: string
    description?: string
    confirmLabel?: string
    cancelLabel?: string
}) {
    return (
        <GenericModal
            opened={opened}
            onClose={onClose}
            title={title}
            size="lg"
            contentClassName="!rounded-[3px] !bg-ds-elevation-surface-overlay !shadow-[0_0_1px_0_var(--shadow-overlay-first,rgba(9,30,66,0.31)),0_8px_12px_0_var(--shadow-overlay-second,rgba(9,30,66,0.15)),0_0_0_1px_var(--shadow-overlay-third,rgba(188,214,240,0))_inset]"
        >
            <div
                style={{
                    display: "grid",
                    padding: `${token("space.300")} ${token("space.300")} ${token("space.200")} ${token("space.300")}`,
                    alignItems: "start",
                    gap: token("space.200"),
                    alignSelf: "stretch",
                }}
            >
                <div
                    style={{
                        color: token("color.text"),
                        fontFeatureSettings: "'liga' off, 'calt' off",
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "20px",
                    }}
                >
                    {description}
                </div>
                <div className="w-full grid grid-flow-col justify-end gap-2">
                    <AnankeButton type="button" appearance="default" onClick={onClose}>
                        {cancelLabel}
                    </AnankeButton>
                    <AnankeButton type="button" appearance="danger" onClick={onConfirm}>
                        {confirmLabel}
                    </AnankeButton>
                </div>
            </div>
        </GenericModal>
    );
}
